import { useIntl } from 'react-intl'
import { FormattedMessage } from 'react-intl'

import theme from 'theme_'
import { useAppSelector } from 'app/hooks'
import { FooterMessages } from './messages'
import {
  FooterWrapper,
  FooterNameWrapper,
  FooterLinksContainer,
  StyledFooterLink,
  FooterName,
} from './styles'
import { Secondary } from 'components/Typography'

const currentYear = new Date().getFullYear()

function Footer() {
  const { formatMessage } = useIntl()

  const { open: asideOpen } = useAppSelector((state) => state.aside)

  const isDesktop = window.matchMedia(theme.devices.desktop).matches

  let links = [
    {
      url: 'https://community.savant.com/',
      text: FooterMessages.integratorCommunity,
    },
    {
      url: 'https://www.savant.com/savant-pro-app',
      text: FooterMessages.savantProApp,
    },
    {
      url: 'https://www.savant.com/terms-and-conditions',
      text: FooterMessages.termsOfService,
    },
    {
      url: 'https://store.savant.com',
      text: FooterMessages.store,
    },
    {
      url: 'https://www.savant.com/',
      text: FooterMessages.savantCom,
    },
    {
      url: 'https://www.savant.com/privacy-policy',
      text: FooterMessages.privacyPolicy,
    },
  ]

  if (!isDesktop) {
    links = [
      {
        url: 'https://community.savant.com/',
        text: FooterMessages.integratorCommunity,
      },
      {
        url: 'https://www.savant.com/',
        text: FooterMessages.savantCom,
      },
      {
        url: 'https://store.savant.com',
        text: FooterMessages.store,
      },
      {
        url: 'https://www.savant.com/terms-and-conditions',
        text: FooterMessages.termsOfService,
      },
      {
        url: 'https://www.savant.com/savant-pro-app',
        text: FooterMessages.savantProApp,
      },
      {
        url: 'https://www.savant.com/privacy-policy',
        text: FooterMessages.privacyPolicy,
      },
    ]
  }

  return (
    <FooterWrapper aside={asideOpen}>
      <FooterNameWrapper>
        <FooterName>
          <FormattedMessage
            {...FooterMessages.scm}
            values={{ version: process.env.REACT_APP_VERSION }}
          />
        </FooterName>
        <Secondary color={theme.colors.otterWarmBlack}>
          <FormattedMessage
            {...FooterMessages.copyright}
            values={{ currentYear }}
          />
        </Secondary>
      </FooterNameWrapper>

      <FooterLinksContainer>
        {links.map((link) => (
          <StyledFooterLink key={link.url} href={link.url} target="_blank">
            {formatMessage(link.text)}
          </StyledFooterLink>
        ))}
      </FooterLinksContainer>
    </FooterWrapper>
  )
}

export default Footer
